'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationFieldContainer = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _bound = require('redux/saga/entities/bound');

var _deep = require('helpers/deep');

var _SearchBox = require('./SearchBox.saga');

var _Search = require('../Search.constants');

var _SearchBox2 = require('./SearchBox.constants');

var _LocationField = require('./LocationField');

var _SearchBox3 = require('./SearchBox.reducer');

var mapDispatchToProps = {
  onFieldFocus: _SearchBox3.setOpenPanel.bind(null, _SearchBox2.PANEL_NAMES.location),
  onSelect: _SearchBox.searchPanelItemSelected.bind(null, _SearchBox2.PANEL_NAMES.location),
  onRemoveItem: _SearchBox.removeSearchboxHistoryItem.bind(null, _SearchBox2.PANEL_NAMES.location),
  onClose: _SearchBox3.closeOpenPanel,
  onClear: _SearchBox3.clearLocationField,
  onValueChange: _SearchBox3.setLocationFieldValue
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var searchBox = (0, _SearchBox3.selectSearchBoxState)(state);
  var lastKeyToHaveLoaded = searchBox.locationKey,
      inputValue = searchBox.locationFieldValue;

  var _searchLayoutByName$s = _bound.searchLayoutByName.select(state, _Search.HEADER_LAYOUT),
      headerDataLoading = _searchLayoutByName$s.loading,
      headerData = _searchLayoutByName$s.data;

  var predictionData = _bound.searchLocationAutocomplete.data(state, searchBox.locationFieldValue);
  var isLoading = !!headerDataLoading || inputValue && lastKeyToHaveLoaded !== inputValue;

  return {
    inputValue: inputValue,
    blurredValue: (0, _deep.deepExtract)('locationName', searchBox.selectedLocation || searchBox.defaultLocation, ''),
    suggestions: predictionData && predictionData.predictions || [],
    history: (0, _deep.deepExtract)('location_history.data.location_history', headerData, []),
    isLoading: isLoading
  };
};

var LocationFieldContainer = exports.LocationFieldContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LocationField.LocationField);